import AdobeTagManager from './adobe-tag-manager';

export { AdobeTagManager };
